export default "__VITE_ASSET__8_7glvlu__"